module.exports = __webpack_public_path__ + "media/customizations/amblebrook/logo-new-721f21ab7dd9d9308fd99b7e9c29d9a3.png";